export default __webpack_public_path__ + "static/margins-before-5e27c8ceef22e54613ffb4040b66d434.png";